import { MonthlyProductionStatus } from '../types'

export const monthlyHistoryStatusLabelKey = (
  status: MonthlyProductionStatus
): string => {
  if (status === 'paid') return 'financial.monthlyHistory.statusPaid'
  if (status === 'current') return 'financial.monthlyHistory.statusCurrent'
  return 'financial.monthlyHistory.statusClosed'
}
